const rfc6902 = require('rfc6902');

class StoredEntity {

	constructor() {
		this._meta = {};
		this._origData = {};
	}

	getId() {
		return this._meta.id;
	}

	getAlias() {
		return this._meta.alias;
	}

	setAlias(a) {
		this._meta.alias = a;
	}

	getAttributeSet() {
		return this._meta.attributeset;
	}

	getAttributeRev() {
		return this._meta.attributerev;
	}

	getEntityclass() {
		return this._meta.entityclass;
	}

	getRev() {
		return this._meta.rev;
	}

	getDeleted() {
		return !!this._meta.deleted;
	}

	getCreated() {
		return this._meta.created;
	}

	fromData(data, setters) {
		this._getKeys().forEach(key => {
			if (typeof data[key] === 'undefined') return;
			if (setters) {
				let setter = `set${key[0].toUpperCase()}${key.substr(1)}`;
				if (typeof this[setter] === 'function') {
					this[setter](data[key]);
				} else {
					this[key] = data[key];
				}
			} else {
				this[key] = data[key];
			}
		});
	}

	fromStorage(entity) {
		let meta = {...entity};
		delete meta.data;
		this._meta = meta;
		if (entity.data) {
			this._origData = JSON.parse(JSON.stringify(entity.data));
			this.fromData(entity.data);
		}
	}

	toStorage() {
		const res = {};
		this._getKeys().forEach(key => {
			if (this[key] !== null) {
				res[key] = this[key];
			}
		});
		return res;
	}

	toEntity() {
		return {
			...this._meta,
			data: this.toStorage()
		};
	}

	toExternal() {
		let data = this.toStorage();
		data.id = this.getId();
		return data;
	}

	_getKeys() {
		return Object.keys(this).filter(k => k[0] !== '_');
	}

	getPatch() {
		let currentData = this.toStorage();
		let patch = rfc6902.createPatch(this._origData, currentData);
		return patch;
	}

}

module.exports = StoredEntity;
